import React from 'react';
import TaskDetailsMasterLayer from './TaskDetailsMasterLayer.component';


const DocumentTaskDetail = (props) => {
    return <TaskDetailsMasterLayer {...props}></TaskDetailsMasterLayer>;

};
export default DocumentTaskDetail
